import { get, put } from "../../utils/httpClient";

const userPreferencesService = () => {
  const prefixApi = "duedates/userpreferences";

  const getUserPreferences = async (userId) => {
    return await get(`/${prefixApi}/${userId}`);
  };

  const updateUserPreferences = async (json) => {
    return await put(`/${prefixApi}`, json);
  };

  return {
    getUserPreferences,
    updateUserPreferences,
  };
};

export default userPreferencesService;
